import apiRouteMapping from '@/features/app/constants/api-route-mapping';
import captureSentryException from '@/features/app/functions/captureSentryException';
import useAppSelector from '@/features/app/hooks/useAppSelector';
import { Notification } from '@/features/notifications/types/notification';
import useAuthenticatedQuery from '@/shared/hooks/useAuthenticatedQuery';
import useAxios from '@/shared/hooks/useAxios';
import { UseQueryOptions } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export default function useNotificationQuery(
  {
    order = 'creationDate',
    orderkey = 'desc',
    offset = 0,
    limit = 15,
  }: {
    order?: string;
    orderkey?: 'asc' | 'desc';
    offset?: number;
    limit?: number;
  },
  options: Omit<UseQueryOptions<Array<Notification>>, 'queryKey'> = {}
) {
  const { user } = useAppSelector((state) => state.auth);
  const { i18n } = useTranslation();
  const axios = useAxios();

  return useAuthenticatedQuery<Array<Notification>>({
    queryKey: ['notification', order, orderkey, offset, limit, i18n.language],
    queryFn: async () => {
      return axios
        .get(
          `${apiRouteMapping['/notices']}?${new URLSearchParams({
            userId: user?.id ? user.id.toString() : '',
            lang: i18n.language,
            limit: limit.toString(),
            offset: offset.toString(),
            order,
            orderkey,
          }).toString()}`
        )
        .then((res) => res.data)
        .catch((error) => {
          captureSentryException(error);
          return Promise.reject(error);
        });
    },
    ...options,
  });
}
